import type { ZipCodeType } from '@widget/api/queries/zipcodes/types';
export const isValidZipCode = ({
  options,
  zipCode,
  city,
  region,
}: {
  options?: ZipCodeType[];
  zipCode?: string;
  city?: string;
  region?: string;
}) => {
  if (!options || !zipCode) return false;
  if (city) {
    return options?.some(
      (row) =>
        row.zipCode === zipCode && row.city?.toLocaleLowerCase() === city.toLocaleLowerCase(),
    );
  }
  return options?.some(
    (row) =>
      row.zipCode === zipCode && row.region?.toLocaleLowerCase() === region?.toLocaleLowerCase(),
  );
};
